import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isSynopticElementEventCsvConfiguration(obj: any, eventArgTypeGuard: (eventArg: any) => CsvConfigJsonResult, trigger: 'click' | 'hover'): CsvConfigJsonResult {
  let errors = [];
  let valid = true;

  if (typeof obj !== 'object' ||
    obj === null) {
    errors.push({code: 'invalidEvent', key: ''});
    valid = false;
  }
  if (obj.trigger === undefined) {
    errors.push({code: 'notExist', key: 'trigger'});
    valid = false;
  } else {
    const resultIsTrigger = isTrigger(obj.trigger, trigger);
    if (!resultIsTrigger.result) {
      errors = [...errors, ...resultIsTrigger.errors];
      valid = false;
    }
  }

  if (obj.args === undefined) {
    errors.push({code: 'notExist', key: 'args'});
    valid = false;
  } else {
    const resultEventArgTypeGuard = eventArgTypeGuard(obj.args);
    if (!resultEventArgTypeGuard.result) {
      errors = [...errors, ...resultEventArgTypeGuard.errors];
      valid = false;
    }
  }

  return {result: valid, errors: errors};
}

function isTrigger(obj: any, trigger: 'click' | 'hover'): {
  result: boolean,
  errors: { key: string, code: string }[]
} {
  let valid = true;
  let errors = [];
  if (typeof obj !== 'string' || obj !== trigger) {
    errors.push({code: 'invalidValue', key: 'trigger', value: obj});
    valid = false;
  }


  return {result: valid, errors: errors};
}
